import React, {useState, useEffect} from 'react';
import { Badge, Space, message, Tooltip } from 'antd'; // Import Tooltip
import { FaBell, FaEnvelope, FaUser, FaMoneyBill, FaSignOutAlt, FaBitbucket } from 'react-icons/fa';
import './../../css/BadgeAnt.css';

const BadgeAnt = ({ onMenuSelect }) => {
  const [countContractTinchap, setCountContractTinchap] = useState(1); // Loading state for the skeleton
  const [countContractTragop, setCountContractTragop] = useState(1); // Loading state for the skeleton
  const [username, setUsername] = useState(""); // Loading state for the skeleton


  useEffect(() => {
    setUsername(localStorage.getItem('username'))
  }, [])
  
  
  const handleLogout = () => {
    localStorage.removeItem('token'); // Xóa token khỏi local storage
    message.success('Logged out successfully!'); // Thông báo đăng xuất thành công
    window.location.reload(); // Làm mới trang
  };

  const fetchData = async () => {

    const token = localStorage.getItem('token'); 
           
    const response = await fetch(`${process.env.REACT_APP_API_DB_URL}/count-alert`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`, // Gửi token trong header
        },
    });

    if (response.ok) {
        const data = await response.json()
    //    console.log(data); // Ghi ra dữ liệu trả về

        setCountContractTinchap(data.cnt_credit);
        setCountContractTragop(data.cnt_installment);
    } else {
        // Nếu phản hồi không thành công
    }

    
  };

  useEffect(() => {
    fetchData();
//    console.log("render badge")
  }, []);


  return (
    <Space size="medium">
      <Tooltip title={`Có ${countContractTinchap} hợp đồng tín chấp cần xử lý`}>
        <Badge count={countContractTinchap} overflowCount={999} onClick={() => onMenuSelect('AlertTinchap')}>
          <div className="">
            <FaMoneyBill className="hover-icon" />
          </div>
        </Badge>
      </Tooltip>

      <Tooltip title={`Có ${countContractTragop} hợp đồng trả góp cần xử lý`}>
        <Badge count={countContractTragop} overflowCount={999} onClick={() => onMenuSelect('AlertTragop')}>
          <div className="ml-5" >
            <FaBitbucket className="hover-icon" />
          </div>
        </Badge>
      </Tooltip>


      <div className="ml-10 " style={{ display: 'flex', alignItems: 'center' }}>
        <p className=''><b>{username}</b></p>
        <Tooltip title="Đăng xuất">
          <FaSignOutAlt className="hover-icon ml-3" onClick={handleLogout} />
        </Tooltip>

      </div>
    </Space>
  );
};

export default BadgeAnt;